/**
 *
 * Overview MeetingInfo
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import VideoLink from 'components/VideoConf/VideoLink.jsx';
import listUsers from 'utils/listUsers.js';
import messages from './messages.js';
import { LOCATION_TYPE_LABEL, LOCATION_TYPE_VIDEO } from '../Planner/SelectLocationType/constants.js';

function MeetingInfo(props) {
  const { meeting } = props;
  if (!meeting) {
    return null;
  }
  const { meetingLocationType, videoMeeting } = meeting;
  const { student, parents } = meeting.details;
  const locationLabel = LOCATION_TYPE_LABEL[meetingLocationType];
  return (
    <>
      <div className="col-names">
        <AvatarWithText src={student.avatar}>{student.displayName}</AvatarWithText>
      </div>
      <div className="col-location text-nowrap">
        {locationLabel && <FormattedMessage {...locationLabel} />}
        {meetingLocationType === LOCATION_TYPE_VIDEO && videoMeeting && (
          <VideoLink {...videoMeeting} className="d-print-none btn btn-default ms-2 py-1">
            <FormattedMessage {...messages.join} />
          </VideoLink>
        )}
      </div>
      <div className="col-parents small text-end ps-3">{listUsers(parents)}</div>
    </>
  );
}

MeetingInfo.propTypes = {
  meeting: PropTypes.object,
};

export default MeetingInfo;
